<template>
  <div class="container-fluid">
    <v-card
      color="red"
      flat
      tile
      class="d-print-none"
    >
      <v-toolbar dense
                 src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      >
        <v-spacer></v-spacer>
        <v-btn
          @click="exportExc"
          outlined
          color="error"
          v-if="toolbarButtonsVisible"
        >
          Excel export
        </v-btn>
        <v-btn
          @click="exportPdf"
          outlined
          color="error"
          v-if="toolbarButtonsVisible"
        >
          PDF export
        </v-btn>
        <v-dialog
          max-width="500"
          v-model="exportDialog">
          <ExportOrdersForm
            v-if="exportDialog"
            :type="exportType"
            :orders="orders"
            @exported="exportDialog = false"
          ></ExportOrdersForm>
        </v-dialog>

        <v-dialog
          v-model="ordersDialog"
          max-width="1050"
          persistent
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="currentUser.roleId === 1 || currentUser.roleId === 2 || currentUser.roleId === 3"
              color="white"
              outlined
              dark
              v-bind="attrs"
              v-on="on"
              @click="editedItem = defaultItem"
              v-show="toolbarButtonsVisible"
            >
              Nová objednávka
            </v-btn>
          </template>
          <OrderForm
            :order="editedItem"
            v-if="ordersDialog"
            @order-canceled="ordersDialog = false; getOrders()"
            @order-finished="getOrders"
          ></OrderForm>
        </v-dialog>
        <v-dialog
          v-model="orderStateDialog"
          max-width="500"
        >
        <OrderStateForm
          v-if="orderStateDialog"
          :order="editedItem"
          @data-saved="getOrders"
        ></OrderStateForm>
        </v-dialog>
        <v-dialog
          v-model="orderPaidDialog"
          max-width="500"
        >
          <OrderPaidForm
            v-if="orderPaidDialog"
            :order="editedItem"
            @data-saved="getOrders"
          ></OrderPaidForm>
        </v-dialog>
      </v-toolbar>
    </v-card>
    <v-alert type="error" v-if="invoiceErrorAlert">Chyba při vytváření faktury.</v-alert>
    <v-expansion-panels flat tile>
      <v-expansion-panel class="elevation-0">
        <v-expansion-panel-header>Poznámky k objednávkám</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Číslo objednávky
                </th>
                <th class="text-left">
                  Datum vytvoření
                </th>
                <th class="text-left">
                  Stav
                </th>
                <th class="text-left">
                  Poznámka
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="order in orders"
                :key="order.id"
              >
                <td v-if="filterDescriptions(order)">{{ order.id }}</td>
                <td v-if="filterDescriptions(order)">{{ order.created }}</td>
                <td v-if="filterDescriptions(order)">{{ order.state }}</td>
                <td v-if="filterDescriptions(order)">{{ order.description }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
<!--          <v-data-table-->
<!--            :headers="headersDescriptions"-->
<!--            :items="orders"-->
<!--            :items-per-page="8"-->
<!--          >-->
<!--          </v-data-table>-->
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-data-table
      ref="ordersTable"
      :loading="loading"
      :headers="headers"
      :items="orders"
      multi-sort
      sort-by="orderNumber"
      class="elevation-1 d-print-block"
      :sort-desc="true"
      locale="cs"
      :single-expand="singleExpand"
      show-expand
      :options="dlOptions"
      :footer-props="footerProps"
      :item-class="datatableRowBackground"
    >
      <template v-slot:top>
        <v-toolbar  flat color="white">
          <v-toolbar-title>Objednávky</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
<!--          <v-switch-->
<!--            v-model="onlyFinished"-->
<!--            label="Pouze dokončené"-->
<!--            @change="filterDone"-->
<!--          ></v-switch>-->
          <v-select
            v-model="onlyFinished"
           @change="filterDone"
          :items="stateFilter"
          outlined
          label="Filter stavu"
          single-line
          dense
          hide-details>
          </v-select>
          <v-form class="pt-7">
            <v-container>
              <v-row>
                <v-col>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filters.date"
                        label="Filtr Data"
                        hide-details
                        outlined
                        single-line
                        prepend-icon="mdi-calendar"
                        readonly
                        clearable
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.date"
                      @input="menu2 = false"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-select
                    :items="institutions"
                    label="Filtr instituce"
                    item-text="name"
                    outlined
                    item-value="id"
                    single-line
                    hide-details
                    deletable-chips
                    dense
                    small-chips
                    v-model="filters.institutionId"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-select
                    :items="searchFilterColumns"
                    v-model="filters.searchColumn"
                    outlined
                    small-chips
                    deletable-chips
                    dense
                    label="Sloupec"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="filters.search"
                    append-icon="mdi-magnify"
                    label="Vyhledávání"
                    single-line
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col
                >
                  <v-btn color="primary" :disabled="!filtersFormValid || loading" @click="applyFilter">Filtrovat</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-toolbar>
      </template>
      <template v-slot:item.description="{ item }">
        <v-chip
          v-if="item.description != null"
          color="green"
          dark
        >
          Ano
        </v-chip>
        <v-chip
          v-else
          color="red lighten-2"
          dark
        >
          Ne
        </v-chip>
      </template>
      <template
        v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
        v-slot:item.actions="{ item }"
      >
        <v-icon
          v-if="item.state !== 'Stornovaná'"
          small
          class="mr-2"
          @click="editPaid(item)"
        >
          mdi-cash
        </v-icon>
        <v-icon
          v-if="item.state !== 'Stornovaná'"
          small
          class="mr-2"
          @click="editState(item)"
        >
          mdi-car-info
        </v-icon>
        <v-icon
          v-if="item.state === 'Čekající' && item.paymentTypeId === 1"
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          v-if="item.invoice"
          @click="showInvoice(item, false)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          small
          v-if="item.invoice"
          @click="showInvoice(item, true)"
        >
          mdi-download
        </v-icon>
        <v-btn
          v-else-if="!item.transactionId && item.paymentTypeId !== 1 && item.state !== 'Stornovaná'"
          x-small
          @click="createInvoice(item)"
          :disabled="createInvoiceWait"
        >
          Vytvořit fakturu
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-container>
            <v-row>
              <table>
                <tbody>
                <tr>
                  <td style="font-weight: bold">
                    Strávníci:
                  </td>
                    <td
                      v-for="(boarder, index) in item.boarders" :key="index"
                    >
                      {{ boarder.firstName + ' ' + boarder.lastName + (index !== item.boarders.length - 1 ? ', ' : ' ') }}
                    </td>
                </tr>
                  <tr>
                    <td style="font-weight: bold">
                      Balení:
                    </td>
                    <td>
                      {{ item.customPackaging ? 'Vlastní nádoba' : 'Standardní balení' }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      Rozvoz:
                    </td>
                    <td>
                      {{ item.deliveryType }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold">
                      Poznámka:
                    </td>
                    <td>
                      {{ item.description }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-row>
            <v-row>
              <b>Obsah</b>
              <v-expansion-panels multiple>
                <v-expansion-panel
                  v-for="(day, dateStr, i) in item.items" :key="i"
                >
                  <v-expansion-panel-header>
                    <tr>
                      <th class="cart-heading">{{getLocalizedWeekDay(dateStr)}}</th>
                      <th class="cart-heading">{{getLocalizedDate(dateStr)}}</th>
                      <td class="cart-heading">{{getSelectedTimesStr(day)}}</td>
                    </tr>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div
                      v-for="(time, index) in day"
                      :key="index"
                    >
                      <v-data-table
                        v-if="time.length"
                        :headers="historyHeaders"
                        :items="time"
                      >
                        <template v-slot:top>
                          <v-toolbar flat dense>
                            <v-toolbar-title>{{timeTypes.length ? timeTypes[index].name : ''}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>
                      </v-data-table>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>
    <div class="text-right">
      <v-btn
        color="primary"
        class="mr-2"
        @click="loadNextOrders"
        :disabled="loading"
      >
        Načíst další</v-btn>
      <v-btn color="error"
             class="mr-2"
             @click="flushCache"
             :disabled="loading"
      >
        Vymazat Cache</v-btn>
    </div>
    <v-dialog v-model="invoiceDialog">
      <v-card>
        <InvoiceView
          v-if="invoiceDialog" :invoice="displayedInvoice"
        ></InvoiceView>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OrderForm from '../../components/forms/order/OrderForm'
import OrderStateForm from '../../components/forms/admin/OrderStateForm'
import { mapGetters } from 'vuex'
import InvoiceView from '../../components/InvoiceView'
import ExportOrdersForm from '../../components/forms/admin/ExportOrdersForm'
import OrderPaidForm from '@/components/forms/admin/OrderPaidForm'
export default {
  Name: 'OrdersArchive',
  components: { ExportOrdersForm, OrderStateForm, OrderForm, InvoiceView, OrderPaidForm },
  data () {
    return {
      onlyFinished: '',
      // date: new Date().toISOString().substr(0, 10),
      // datatable controls
      dlOptions: {
        itemsPerPage: 25
      },
      footerProps: { 'items-per-page-options': [25, 30, 50, 100, -1] },
      toolbarButtonsVisible: false,
      loading: true,
      singleExpand: true,
      page: 1,
      stateFilter: ['Vše', 'Pouze dokončené', 'Pouze nedokončené'],
      headers: [
        { text: 'Číslo objednávky', value: 'id', align: 'start', sortable: true },
        { text: 'Poznámka', value: 'description' },
        { text: 'Datum vytvoření', value: 'created' },
        { text: 'Jídelníček', value: 'diet.name' },
        { text: 'Uživ. ID', value: 'user.id' },
        { text: 'Jméno', value: 'user.firstName' },
        { text: 'Příjmení', value: 'user.lastName' },
        { text: 'Ulice', value: 'deliveryStreet' },
        { text: 'čp', value: 'deliveryStreetNumber' },
        { text: 'Město', value: 'deliveryCity' },
        { text: 'PSČ', value: 'deliveryZip' },
        { text: 'Zaplaceno', value: 'paidStr' },
        { text: 'Rozvoz', value: 'deliveryType' },
        { text: 'Celková cena', value: 'price' },
        { text: 'Cena za 1 baleni', value: 'packagingPrice' },
        { text: 'Způsob platby', value: 'paymentType' },
        { text: 'Stav', value: 'state' },
        { text: 'Akce', value: 'actions', sortable: false }
      ],
      historyHeaders: [
        { text: '', value: 'photo', sortable: false },
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name',
          width: 300
        },
        { text: 'Alergeny', value: 'alergensStr' },
        { text: 'Kalorie', value: 'calories' },
        { text: 'Cena', value: 'price' },
        { text: '', value: 'data-table-expand' },
        { text: 'Množství', value: 'datatableQuantity' },
        { text: 'E-mail řidiče', value: 'driverMail' }
      ],
      // headersDescriptions: [
      //   { text: 'Číslo objednávky', value: 'id', align: 'start', sortable: true },
      //   { text: 'Datum vytvoření', value: 'created' },
      //   { text: 'Stav', value: 'state' },
      //   { text: 'Poznámka', value: 'description' }
      // ],
      // filters
      menu2: false,
      menu: false,
      searchFilterColumns: [
        { text: 'Číslo objednávky', value: 'id' },
        { text: 'Datum vytvoření', value: 'order_date' },
        { text: 'Jídelníček', value: 'diet_name' },
        { text: 'Uživ. ID', value: 'user_id' },
        { text: 'Jméno', value: 'first_name' },
        { text: 'Příjmení', value: 'last_name' },
        { text: 'Ulice', value: 'delivery_street' },
        { text: 'čp', value: 'delivery_street_number' },
        { text: 'Město', value: 'delivery_city' },
        { text: 'PSČ', value: 'delivery_zip' },
        { text: 'Rozvoz', value: 'delivery_type' },
        { text: 'Celková cena', value: 'price' },
        { text: 'Způsob platby', value: 'payment_type' },
        { text: 'Stav', value: 'state' }
      ],
      filters: {
        institutionId: null,
        search: '',
        date: null,
        searchColumn: null
      },
      // create/update order
      editedItem: {},
      defaultItem: {
        id: null,
        shoppingCart: {
          boarders: [],
          user: null,
          diet: {},
          dietId: null,
          order: false,
          customPackaging: 1,
          deliveryType: 'Rozvoz',
          paymentTypeId: 1,
          description: null,
          items: {}
        },
        state: null,
        dates: []
      },
      orderStateDialog: false,
      orderPaidDialog: false,
      ordersDialog: false,
      // invoices
      createInvoiceWait: false,
      invoiceErrorAlert: false,
      invoiceDialog: false,
      displayedInvoice: null,
      // exports
      exportType: 'pdf',
      exportDialog: false,
      // data arrays
      institutions: [],
      orders: [],
      ordersDesc: [],
      timeTypes: [],
      diets: [],
      invoices: []
    }
  },
  created () {
    this.initialize()
    this.getInstitutions()
  },

  methods: {
    filterDone () {
      if (this.onlyFinished === 'Pouze dokončené') {
        this.stateFilter = ['Vše']
        this.orders = this.orders.filter(function (order) {
          return order.state === 'Dokončená'
        })
      } else if (this.onlyFinished === 'Pouze nedokončené') {
        this.stateFilter = ['Vše']
        this.orders = this.orders.filter(function (order) {
          return order.state === 'Čekající'
        })
      } else {
        this.stateFilter = ['Vše', 'Pouze dokončené', 'Pouze nedokončené']
        this.initialize()
      }
    },
    filterDescriptions (order) {
      const date = order.created.split('-')
      if (order.description != null && date < date + 14) return true
      return false
    },
    initialize () {
      this.$http.get('/admin/invoices')
        .then(response => {
          this.invoices = this.keysToCamelCase(response.data)
        })
        .catch(err => { console.log(err) })
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
        })
        .catch(err => console.log(err))
      this.$http.get('/admin/diets')
        .then(response => {
          this.diets = this.keysToCamelCase(response.data)
        })
        .catch(err => { console.log(err) })
      this.getOrders()
    },
    getInstitutions () {
      this.$http.get('/admin/institutions')
        .then(response => {
          this.institutions = this.keysToCamelCase(response.data)
        })
    },
    getOrders () {
      this.orders = []
      this.page = 1
      this.loading = true
      this.toolbarButtonsVisible = false
      this.ordersDialog = false
      this.orderStateDialog = false
      this.orderPaidDialog = false
      this.loadNextOrders()
    },
    loadNextOrders () {
      this.filters = {
        institutionId: null,
        search: '',
        date: null,
        searchColumn: null
      }
      this.loading = true
      this.$http.get('/admin/orders?page=' + this.page + '&archive=1')
        .then(response => {
          ++this.page
          const tmpOrders = this.keysToCamelCase(response.data)
            .map(this.mapOrders)
          this.orders = this.orders.concat(tmpOrders)
          this.loading = false
          this.toolbarButtonsVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    mapOrders (order) {
      order.dates = Object.keys(order.items)
      order.created = new Date(order.createdAt).toISOString().slice(0, 10)
      // order.created = new Date(order.createdAt).toLocaleDateString('cs-cz')
      order.paidStr = order.paid ? 'Ano' : 'Ne'
      switch (order.paymentTypeId) {
        case 1: order.paymentType = 'Kredit'; break
        case 3: order.paymentType = 'Při převzetí'; break
        case 4: order.paymentType = 'Bankovní převod'; break
        case 5: order.paymentType = 'Kartou online'; break
      }
      for (const date in order.items) {
        order.items[date] = order.items[date].map(time => {
          time = time.map(item => {
            item.datatableQuantity = item.quantity * (order.boarders.length + +order.order)
            item.alergensStr = item.alergens
              .map(alergen => alergen.name)
              .join(', ')
            return item
          })

          return time
        })
      }
      return order
    },
    getLocalizedDate (dateStr) {
      const date = new Date(dateStr)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    getLocalizedWeekDay (dateStr) {
      const date = new Date(dateStr)
      const localeDayStr = date.toLocaleDateString('cs-cz', { weekday: 'long' })
      return localeDayStr[0].toUpperCase() + localeDayStr.slice(1)
    },
    getSelectedTimesStr (itemsArr) {
      let timeNames = []
      if (this.timeTypes.length) {
        timeNames = [0, 1, 2, 3, 4, 5]
          .map(time => this.timeTypes[time].name)
      }
      return timeNames
        .filter((time, index) => itemsArr[index].length)
        .join(', ')
    },
    editState (item) {
      this.editedItem = Object.assign({}, item)
      this.orderStateDialog = true
    },
    editPaid (item) {
      this.editedItem = Object.assign({}, item)
      this.orderPaidDialog = true
    },
    editItem (item) {
      console.log(item)
      const itemParam = {
        ...item,
        shoppingCart: {
          ...item,
          customPackaging: !!item.customPackaging,
          boarders: item.boarders
            .map(boarder => {
              boarder.fullName = `${boarder.firstName} ${boarder.lastName}`
              return boarder
            }),
          user: {
            ...item.user,
            fullName: `${item.user.firstName} ${item.user.lastName}`
          }
        },
        dates: item.dates
      }
      this.editedItem = { ...itemParam }
      this.ordersDialog = true
    },
    showInvoice (item, print) {
      // this.displayedInvoice = item.invoice
      // this.invoiceDialog = true
      this.$http({
        method: 'POST',
        url: '/admin/invoices/download',
        responseType: 'blob',
        data: {
          invoice_id: item.invoice.id
        }
      })
        .then(response => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)

          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'Faktura ' + item.invoice.id + '.pdf')
          document.body.appendChild(fileLink)

          print ? fileLink.click() : window.open(fileURL)
        })
        .catch(error => {
          console.log(error)
        })
    },
    createInvoice (order) {
      this.createInvoiceWait = true
      this.$http.post('/admin/invoices/create', this.keysToSnakeCase({
        userId: order.userId,
        orderId: order.id
      }))
        .then(response => {
          order.invoice = this.keysToCamelCase(response.data)
          this.createInvoiceWait = false
        })
        .catch(() => {
          this.createInvoiceWait = false
          this.invoiceErrorAlert = true
          setTimeout(() => {
            this.invoiceErrorAlert = false
          })
        })
    },
    exportExc () {
      this.exportType = 'xlsx'
      this.exportDialog = true
    },
    exportPdf () {
      this.exportType = 'pdf'
      this.exportDialog = true
    },
    flushCache () {
      this.loading = true
      this.$http.delete('admin/orders/cache')
        .then(res => {
          this.getOrders()
        })
    },
    datatableRowBackground (item) {
      return item.state === 'Nezaplacená' ? 'red darken-1' : 'paid-order'
    },
    applyFilter () {
      this.loading = true
      this.$http.post('admin/orders/filter?archived=1', this.keysToSnakeCase(this.filters))
        .then(res => {
          this.orders = this.keysToCamelCase(res.data)
            .map(this.mapOrders)
            .sort((a, b) => b.id - a.id)
        })
        .finally(() => {
          this.loading = false
        })
      /* Object.entries(val).forEach(([key, value]) => {
        console.log(`${key}: ${value}`)
      }) */
    }
  },
  computed: {
    filtersFormValid () {
      const searchTrim = this.filters.search.trim()
      // neni vybrany sloupec
      if (!this.filters.searchColumn && searchTrim) {
        return false
      }
      // vsechny prazdne
      if (!searchTrim && !this.filters.institutionId && !this.filters.date) {
        return false
      }
      return true
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  }
}
</script>

<style scoped>

</style>
